module.exports = "<div class=\"$keyframePropertyDetail fill\"></div>\n"